<template lang="pug">
.loader
	span
	span
	span
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "Loader",
	data() {
		return {
			
		};
	},
	computed: {
		...mapGetters([
			
		]),
	},
	methods: {
		
	},
	created() {
		
	},
};
</script>


<style scoped lang="scss">
.loader {
	display: flex;
	gap: 1.5rem;
	height: 140px;
	width: 100%;
	justify-content: center;
	align-items: center;
	margin: 1rem 0 3rem;
	.blog-listing & {
		margin: 3rem 0;
	}
	span {
		height: 18px;
		width: 18px;
		min-width: 18px;
		border-radius: 50%;
		animation: pulse infinite 1.25s ease-out;
		background: $blue;
		@for $i from 1 through 3 {
			&:nth-child(#{$i}) {
				animation-delay: calc((#{$i} - 1) * 0.225s);
			}
		}
	}
}

@keyframes pulse {
	0% {
		transform: scale(1);
	}
	30% {
		transform: scale(1.75);
	}
	60% {
		transform: scale(1);
	}
}
</style>